import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Assets from '../helpers/Assets';
import t from '../lib/I18n';
import config from '../config';

const PoweredBy = ({className}) => {
    return (
        <a target="_blank" href={config.get('poweredByUrl')} className={cx('powered-by', className)}>
            {t('poweredBy.text')}
            <img
                src={Assets.assetUrl('images/otrl-logo-circle.png')}
                alt=""
                className="powered-by__logo"
            />
            <span className="sr-only">{t('global.externalLink')}</span>
        </a>
    );
};

PoweredBy.propTypes = {
    className: PropTypes.string,
};

export default React.memo(PoweredBy);



// WEBPACK FOOTER //
// ./src/components/PoweredBy.js